import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderSlot as _renderSlot, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "head" }
const _hoisted_2 = { class: "name" }
const _hoisted_3 = { class: "source-icon" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "summary" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_SourceIcon = _resolveComponent("SourceIcon")
  const _component_SourceType = _resolveComponent("SourceType")
  const _component_Popover = _resolveComponent("Popover")

  return (_openBlock(), _createBlock(_component_Popover, {
    width: "32.1rem",
    "show-arrow": false,
    disabled: $props.disabled,
    "show-after": 200,
    placement: "bottom-start",
    trigger: "hover",
    onHide: _cache[1] || (_cache[1] = $event => (_ctx.$emit('hide'))),
    onShow: _cache[2] || (_cache[2] = $event => (_ctx.$emit('show')))
  }, {
    reference: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default", {}, undefined, true)
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(["source-popover", {internal: $options.internal, pointer: $options.can_click}]),
        onClick: _cache[0] || (_cache[0] = $event => ($options.onClick()))
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_SourceIcon, { data: $props.data }, null, 8 /* PROPS */, ["data"]),
          _createElementVNode("span", _hoisted_2, _toDisplayString($options.name), 1 /* TEXT */),
          _createElementVNode("div", _hoisted_3, [
            ($options.internal)
              ? (_openBlock(), _createElementBlock("span", _hoisted_4, "Internal"))
              : _createCommentVNode("v-if", true),
            _createVNode(_component_SourceType, {
              type: $options.internal ? 'internal' : $options.type
            }, null, 8 /* PROPS */, ["type"])
          ])
        ]),
        _createElementVNode("div", _hoisted_5, _toDisplayString($options.summary), 1 /* TEXT */)
      ], 2 /* CLASS */)
    ]),
    _: 3 /* FORWARDED */
  }, 8 /* PROPS */, ["disabled"]))
}